<template>
	<div id="ap">
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%">
					<a-row type="flex" justify="space-between">
						<a-col span="8">
							<common-page-btn @add="$refs.activityFormRef.show()"></common-page-btn>
						</a-col>
						<a-col span="16">
							<a-row type="flex" align="middle" justify="end" :gutter="10">
								<a-col span="6">
									<a-input v-model="param.title" allowClear search @pressEnter="getList" @on-clear="getList" placeholder="活动标题"></a-input>
								</a-col>
								<a-col span="5">
									<a-select style="width: 100%" v-model="param.status" allowClear placeholder="活动状态" @change="getList">
										<a-select-option :value="0">未开始</a-select-option>
										<a-select-option :value="1">进行中</a-select-option>
										<a-select-option :value="2">已结束</a-select-option>
									</a-select>
								</a-col>
								<a-col span="8">
									<choose-organ v-model="param.organId" @change="organChange" allowClear></choose-organ>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-layout>
			<a-layout-content>
				<a-table :scroll="{ x: '100%' }" :pagination="false" :style="{ background: '#FFF' }" size="small" row-key="activityId" border :columns="keys" ref="list" :loading="loading" :data-source="data.records">
					<template slot-scope="row" slot="title">
						<a href="#" @click="viewStats(row)">{{ row.title }}</a>
					</template>
					<template slot-scope="row" slot="poster">
						<img v-if="row.poster" :src="row.poster" style="width: 60px; height: 40px; object-fit: cover; border-radius: 4px;" />
					</template>
					<template slot-scope="row" slot="stats">
						<a-space direction="vertical" size="small">
							<span>报名商家：{{ row.applyStoreCount }}</span>
							<span>浏览：{{ row.viewCount }}</span>
							<span>分享：{{ row.shareCount }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="time">
						<a-space direction="vertical" size="small">
							<span>开始：{{ row.startTime }}</span>
							<span>结束：{{ row.endTime }}</span>
							<span>报名截止：{{ row.applyEndTime }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="status">
						<a-tag v-if="row.status == '进行中'" color="green">进行中</a-tag>
						<a-tag v-else-if="row.status == '已结束'" color="default">已结束</a-tag>
						<a-tag v-else color="orange">未开始</a-tag>
					</template>
					<template slot-scope="row" slot="action">
						<a-button-group shape="circle" size="small">
							<a-tooltip title="商品审核">
								<a-button type="link" icon="shopping" @click="goGoods(row)"></a-button>
							</a-tooltip>
							<a-tooltip title="订单管理">
								<a-button type="link" icon="file-text" @click="goOrder(row)"></a-button>
							</a-tooltip>
							<a-tooltip title="生成二维码">
								<a-button type="link" icon="qrcode" @click="generateQrCode(row)"></a-button>
							</a-tooltip>
							<a-tooltip title="编辑">
								<a-button type="link" icon="edit" @click="$refs.activityFormRef.show(row)"></a-button>
							</a-tooltip>
							<a-tooltip title="删除">
								<a-button type="link" icon="delete" @click="del(row.activityId)"></a-button>
							</a-tooltip>
						</a-button-group>
					</template>
				</a-table>
			</a-layout-content>
		</a-layout>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
		<activity-form ref="activityFormRef" @success="doRefresh"></activity-form>

		<a-modal v-model="statsVisible" title="活动统计数据" width="500px" :footer="null">
			<a-descriptions :column="2" bordered size="small" v-if="statsData">
				<a-descriptions-item label="报名商家数量">{{ statsData.applyStoreCount }}</a-descriptions-item>
				<a-descriptions-item label="报名商品数量">{{ statsData.applyGoodsCount }}</a-descriptions-item>
				<a-descriptions-item label="审核通过商品">{{ statsData.passGoodsCount }}</a-descriptions-item>
				<a-descriptions-item label="浏览次数">{{ statsData.viewCount }}</a-descriptions-item>
				<a-descriptions-item label="分享次数">{{ statsData.shareCount }}</a-descriptions-item>
				<a-descriptions-item label="订单数量">{{ statsData.orderCount }}</a-descriptions-item>
				<a-descriptions-item label="支付订单">{{ statsData.paidOrderCount }}</a-descriptions-item>
				<a-descriptions-item label="核销订单">{{ statsData.verifyCount }}</a-descriptions-item>
				<a-descriptions-item label="销售总金额" :span="2">{{ statsData.totalSales }} 元</a-descriptions-item>
			</a-descriptions>
		</a-modal>

		<a-modal v-model="qrCodeVisible" title="活动二维码" width="400px" :footer="null" centered>
			<div style="text-align: center;">
				<img :src="qrCodeUrl" alt="活动二维码" style="width: 300px; height: 300px;" />
				<div style="margin-top: 16px;">
					<a-button type="primary" icon="download" @click="downloadQrCode">下载二维码</a-button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import apiUtil from '@/common/apiUtil';
import utils from '@/common/utils';
import activityForm from './components/activity-form.vue';
export default {
	components: { activityForm },
	data() {
		return {
			loading: false,
			statsVisible: false,
			statsData: null,
			qrCodeVisible: false,
			qrCodeUrl: '',
			data: { records: [] },
			param: {
				page: 1,
				limit: 20,
				title: '',
				status: '',
				organId: apiUtil.getDefaultOrganId()
			},
			keys: [
				{ title: '海报', scopedSlots: { customRender: 'poster' }, width: 100, align: 'center' },
				{ title: '活动标题', scopedSlots: { customRender: 'title' }, ellipsis: true },
				{ title: '统计数据', scopedSlots: { customRender: 'stats' }, width: 150, align: 'center' },
				{ title: '活动时间', scopedSlots: { customRender: 'time' }, width: 220, align: 'center' },
				{ title: '状态', scopedSlots: { customRender: 'status' }, width: 100, align: 'center' },
				{ title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 220 }
			]
		};
	},
	created() {
		this.doRefresh();
	},
	methods: {
		organChange() {
			this.doRefresh();
		},
		viewStats(row) {
			this.http.get('/platform/activity/stats/' + row.activityId).then(ret => {
				if (ret.code == 200) {
					this.statsData = ret.data;
					this.statsVisible = true;
				}
			});
		},
		goGoods(row) {
			this.$router.push({ path: '/customer/activity/goods', query: { activityId: row.activityId, title: row.title } });
		},
		goOrder(row) {
			this.$router.push({ path: '/customer/activity/order', query: { activityId: row.activityId, title: row.title } });
		},
		del(id) {
			this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
				utils.showSpin();
				this.http.post('/platform/activity/delete/' + id).then(ret => {
					if (ret.code == 200) {
						this.utils.success('操作成功！').then(() => {
							this.getList();
						});
					}
				});
			});
		},
		getList() {
			this.loading = true;
			this.http
				.get('/platform/activity/list', this.param)
				.then(ret => {
					this.data = ret.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getNext(page, pageSize) {
			this.param.page = page;
			this.param.limit = pageSize;
			this.getList();
		},
		setLimit(current, size) {
			this.param.limit = size;
			this.param.page = 1;
			this.getList();
		},
		doRefresh() {
			this.param.page = 1;
			this.getList();
		},
		generateQrCode(row) {
			this.http.get('/platform/activity/qrcode/' + row.activityId, {}, 'blob').then(ret => {
				const url = URL.createObjectURL(ret);
				this.qrCodeUrl = url;
				this.qrCodeVisible = true;
			}).catch(err => {
				this.utils.error('生成二维码失败');
			});
		},
		downloadQrCode() {
			const a = document.createElement('a');
			a.href = this.qrCodeUrl;
			a.download = '活动二维码_' + Date.now() + '.png';
			a.click();
			URL.revokeObjectURL(this.qrCodeUrl);
		}
	}
};
</script>

<style scoped>
#ap {
	padding: 15px;
}
</style>
